"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Signature = void 0;
const types_1 = require("@near-js/types");
class Signature extends types_1.Assignable {
}
exports.Signature = Signature;
